<template>
  <div class="cta-row" :class="{ 'h500': use500 }">
    <img src="./img/cta-mobile-glow.svg" class="cta-mobile" alt=""  @click="$emit('action')">
    <img v-if="!use500" src="./img/cta-desktop-glow.svg" class="cta-desktop" alt=""  @click="$emit('action')">
    <img v-if="use500" src="./img/cta-500.svg" class="cta-desktop-500" alt=""  @click="$emit('action')">
    <div class="cta-text" @click="$emit('action')">&nbsp;{{ text }}&nbsp;</div>
  </div>
</template>

<script>
export default {
  props: {
    use500: {
      default: false
    },
    text: {
      default: 'CTA ACTION'
    }
  }
}
</script>

<style scoped>
.cta-row{
    margin-top: 25px;
    width: 100%;
    display: flex;
    justify-content: center;
    position: relative;
}
.cta-text{
  font-size: 16px;
  /* Submit: */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  color: #FFFFFF;
  letter-spacing: 2px;
  text-align: center;
  line-height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
}
.cta-desktop{
    position: absolute;
    top: -4px;
    left: -4px;
    display: block;
}
.cta-desktop-500{
    position: absolute;
    top: -4px;
    left: -4px;
    display: block;
}
.cta-mobile{
    position: absolute;
    top: -4px;
    left: -4px;
    display: block;
}

@media screen and (min-width: 319px) {
    .cta-desktop-500{
      display: none;
    }
    .cta-desktop{
      display: none;
    }
    .cta-mobile{
      width: 304px;
      left: calc(50% - 304px / 2);
    }
    .cta-text{
      height: 51px;
    }
}

@media screen and (min-width: 374px) {
    .cta-mobile{
    }
}

@media screen and (min-width: 413px) {
    .cta-mobile{
    }
}

@media screen and (min-width: 767px) {
    .cta-mobile{
        display: none;
    }
    .cta-desktop{
        display: block;
        width: 400px;
        left: calc(50% - 400px / 2);
    }
    .cta-desktop-500{
        display: block;
        width: 500px;
        left: calc(50% - 500px / 2);
    }
    .cta-text{
      font-size: 18px;
      height: 71px;
    }
    .h500 .cta-text{
      height: 53px;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/DOM/CTA/CTA.vue